import { ApiBase } from '@/api/methods/ApiBase'

export namespace TemporaryInformationsApi {
  /**
   * 仮ユーザメールアドレス登録
   *
   * @param mailAddress メールアドレス
   */
  export async function updateInformation(mailAddress: string): Promise<void> {
    const params = {
      mailAddress: mailAddress,
    }
    await ApiBase.post('/activate/informations', params)
  }
}
